import AuthAPI from "./authInstance";

const getAll = async (params = {}) => {
  const response = await AuthAPI.get(`/admin/order/list`, { params });
  return response.data;
};

const getOne = async (data) => {
  const response = await AuthAPI.get(`/admin/order/show/${data}`);
  return response.data;
};

export const orderService = {
  getAll,
  getOne,
};
